import type { InjectedRouter } from 'js/lib/connectToRouter';

export const getCurrentEntityPageNum = (router: InjectedRouter) => {
  const hasPageQuery = router?.location?.query?.page;
  const queryPageNum = Number(hasPageQuery);
  const currentPage: number = queryPageNum > 1 ? queryPageNum : 1;
  return currentPage;
};
